/**
 * OwalSearchContext.js
 *
 * @description Describes context which determines when a search is relevant to an object.
 */

export class OwalSearchContext {
  /**
   * Creates an instance of OwalSearchContext.
   * @param {Array<String>} objectKeys An array of keys for which the context is valid.
   * @memberof OwalSearchContext
   */
  constructor (objectKeys) {
    this.objectKeys = objectKeys
  }

  /**
   * Determines if the context applies to the supplied object.
   *
   * @param {Object} object An object to check for context relevance.
   * @returns Boolean
   * @memberof OwalSearchContext
   */
  appliesToObject (object) {
    return this.objectKeys.map(key => {
      const includes = object.hasOwnProperty(key)
      return includes
    }).any(true)
  }

  /**
   * Determines if the context applies to the supplied key.
   *
   * @param {String} object A key to check for context relevance.
   * @returns Boolean
   * @memberof OwalSearchContext
   */
  appliesToKey (key) {
    return this.objectKeys.includes(key)
  }

  /**
   * Returns an Array containing the values for the keys specified by the context.
   *
   * @param {Object} object The object to retrieve values from.
   * @memberof OwalSearchContext
   */
  valuesFromObject (object) {
    let newObject = {}
    this.objectKeys.forEach(key => {
      // console.debug(`Values from object.`)
      let value = object[key]
      newObject[key] = value
    })

    return newObject
  }

  /**
   * Pulls out the values from a given object that apply to the current context
   *
   * @param {Object} object An object to match against.
   * @returns An array of values.
   * @memberof OwalSearchContext
   */
  matchingValuesFromObject (object) {
    return this.objectKeys.map(key => object[key]).filter(value => !!value)
  }
}
